import EventAgent from '@hotmart/event-agent-js'

export const sendEvent = ({
  system = 'developers',
  entity,
  action,
  event = {},
}) => {
  return EventAgent.send({ system, entity, action, event })
}
